<template>
  <div>
    <v-row
      no-gutters
      align="end"
      class="border-bottom border-normal border-softened pb-4"
    >
      <v-col class="mt-2">
        <h2 v-if="listSource" class="d-sr-only">Authors</h2>
        <ul v-if="listSource" class="no-bullet">
          <AuthorsTag
            v-for="(author, index) in listSource"
            :key="author.id"
            :author="author"
            :index="index"
            :is-last="index === listSource.length - 1"
          />
        </ul>
      </v-col>
      <v-col cols="auto">
        <a
          href="#"
          :aria-expanded="String(isExpanded)"
          aria-controls="correspondingAuthors"
          class="muted--text"
          data-test-id="AuthorDetailsToggleLink"
          @click.prevent="toggleAuthors"
        >
          <span class="d-none d-sm-inline"
            >{{ isExpanded ? "Hide" : "Show" }} author details</span
          ><v-icon class="d-inline-block align-middle">{{
            isExpanded ? mdiChevronUp : mdiChevronDown
          }}</v-icon>
        </a>
      </v-col>
    </v-row>

    <dl
      v-if="isExpanded"
      id="correspondingAuthors"
      class="border-bottom border-normal border-softened overflow-hidden"
    >
      <v-row
        v-for="author in listSource"
        :key="author.id"
        class="border-bottom border-thin border-softened"
      >
        <v-col tag="dt" cols="12" sm="3" class="font-weight-bold"
          >{{ author.firstName }} {{ author.lastName
          }}{{ author.showEmailAddress ? "*" : "" }}</v-col
        >
        <v-col tag="dd" class="d-sm-flex">
          <span class="mr-1 muted--text">Affiliation:</span>
          <span
            v-if="author.institutions.length > 0"
            class="d-sm-flex flex-column"
          >
            <span
              v-for="(institution, index) in author.institutions"
              :key="institution.name"
            >
              <span>{{ institution.name }}</span
              ><span class="d-sm-none">{{
                index !== author.institutions.length - 1 ? "; " : ""
              }}</span>
            </span>
          </span>
          <span v-else>None</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col tag="dt" cols="12" sm="3" class="font-weight-bold"
          >*Corresponding Author{{
            correspondingAuthors.length > 1 ? "s" : ""
          }}</v-col
        >
        <v-col v-if="correspondingAuthors.length > 0" tag="dd">
          <span
            v-for="(correspondingAuthor, index) in correspondingAuthors"
            :key="correspondingAuthor.id"
          >
            <a :href="'mailto:' + correspondingAuthor.emailAddress">{{
              correspondingAuthor.emailAddress
            }}</a
            ><span>{{
              index !== correspondingAuthors.length - 1 ? ", " : ""
            }}</span>
          </span>
        </v-col>
        <v-col v-else tag="dd">None</v-col>
      </v-row>
    </dl>
  </div>
</template>

<script>
import { mdiChevronUp, mdiChevronDown } from "@mdi/js";
import AuthorsTag from "~/components/articles/components/AuthorsTag";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Authors",
  components: {
    AuthorsTag,
  },
  props: {
    listSource: { type: Array, required: true },
  },
  data() {
    return {
      isExpanded: false,
      mdiChevronUp,
      mdiChevronDown,
    };
  },
  computed: {
    correspondingAuthors() {
      return this.listSource.filter((author) => author.showEmailAddress);
    },
  },
  methods: {
    toggleAuthors() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>
